<ng-container *transloco="let t">
<div class="modal-body">
  <div class="row">
    <div class="form-group mb-3">
      <label for="homeInsurance" class="form-label">{{ t('wizard.reoExpenseBreakdown.homeInsurance') }}</label>
      <currency-input [(ngModel)]="reo.hazardInsurance" [name]="'homeInsurance'"
        [allowDecimals]="false" [min]="0" [allowNegative]="false" [placeholder]="t('wizard.reoExpenseBreakdown.homeInsurance')">
      </currency-input>
    </div>

    <div class="form-group mb-3">
      <label for="propertyTax" class="form-label">{{ t('wizard.reoExpenseBreakdown.propertyTax') }}</label>
      <currency-input [(ngModel)]="reo.propertyTax" [name]="'propertyTax'"
        [allowDecimals]="false" [min]="0" [allowNegative]="false" [placeholder]="t('wizard.reoExpenseBreakdown.propertyTax')">
      </currency-input>
    </div>

    <div class="form-group mb-3">
      <label for="associationDues" class="form-label">{{ t('wizard.reoExpenseBreakdown.associationDues') }}</label>
      <currency-input [(ngModel)]="reo.hoa" [name]="'hoa'"
        [allowDecimals]="false" [min]="0" [allowNegative]="false" [placeholder]="t('wizard.reoExpenseBreakdown.associationDues')">
      </currency-input>
    </div>

    <div class="form-group mb-3">
      <label for="miscExpenses" class="form-label">{{ t('wizard.reoExpenseBreakdown.miscExpenses') }}</label>
      <currency-input [(ngModel)]="reo.monthlyMiscExpenses" [name]="'monthlyMiscExpenses'"
        [allowDecimals]="false" [min]="0" [allowNegative]="false" [placeholder]="t('wizard.reoExpenseBreakdown.miscExpenses')">
      </currency-input>
    </div>

  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancelClicked()" data-bs-dismiss="modal">{{ t('common.cancel') }}
  </button>
  <button type="button" class="btn btn-primary" (click)="onOkClicked()">{{ t('common.ok') }}</button>
</div>
</ng-container>
